import { RouteGuard } from "@/router/routeGuard";
import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
    {
      path: "/cadastros/administrativo/usuarios",
      name: "ListagemUsuarios",
      component: () =>
        import(
          /* webpackChunkName: "cadastros-administrativos" */ "@/views/private/cadastros/administrativo/usuarios/ListagemUsuariosAdministrativos.vue"
        ),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/cadastros/administrativo/usuarios/novo",
      name: "CadastroUsuarioAdministrativo",
      component: () =>
        import(
          /* webpackChunkName: "cadastros-administrativos" */ "@/views/private/cadastros/administrativo/usuarios/CadastroUsuarioAdministrativo.vue"
        ),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    {
      path: "/cadastros/administrativo/usuarios/:idUsuario?",
      name: "AlteracaoUsuarioAdministrativo",
      component: () =>
        import(
          /* webpackChunkName: "cadastros-administrativos" */ "@/views/private/cadastros/administrativo/usuarios/CadastroUsuarioAdministrativo.vue"
        ),
      beforeEnter: RouteGuard.acessoAdministrativo
    },
    
]

export default routes;